import React, { useEffect, useState } from 'react'
import { MobileOutlined, SafetyCertificateOutlined } from '@ant-design/icons'
import API from 'api'
import { useHistory } from 'react-router-dom'
import { Form, Input, Row, Col, Button, message, Checkbox, Modal } from 'antd'
import RegisterSteps from './register_steps'
import type { CheckboxChangeEvent } from 'antd/es/checkbox';
import AgreementCom from '../Agreement'
import styles from './style.module.less'
import classNames from 'classnames'

const phoneRules = [
  {
    required: true,
    message: '请输入正确的手机号码',
    pattern: /^1[3|4|5|7|8|9][0-9]\d{8}$/,
  },
]

const captchaRules = [
  {
    required: true,
    message: '请输入正确的验证码',
    pattern: /^\d{6}$/,
  },
]

const QueryCom = () => {
  const [registerForm] = Form.useForm()
  const [sendingCaptcha, setSendingCaptcha] = useState(false)
  const [disabled, setDisabled] = useState(true)
  const [countDown, setCountDown] = useState(60)
  const history = useHistory()

  useEffect(() => {
    var cInterval
    if (sendingCaptcha) {
      cInterval = setInterval(() => {
        setCountDown(countDown - 1)
      }, 1000)
    }
    if (countDown === 0) {
      clearInterval(cInterval)
      setSendingCaptcha(false)
      let pattern = /^1[3|4|5|7|8|9][0-9]\d{8}$/
      if (pattern.test(registerForm.getFieldValue('phone'))) {
        setDisabled(false)
      } else {
        setDisabled(true)
      }
    }
    return () => {
      clearInterval(cInterval)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sendingCaptcha, countDown])

  const register = values => {
    API.Register(values).then(res => {
      if (res.code === 200) {
        history.push({
          pathname: '/register/edit_userInfo',
          state: {
            user: res.data,
          },
        })
      } else if (res.code === 1003) {
        message.error({
          content: '验证码错误,请输入正确的验证码',
          duration: 2,
        })
      } else if (res.code === 1006) {
        message.warning({
          content: '用户已经存在，去登录',
          duration: 2,
        })
      }
    })
  }

  const handleClickCaptcha = () => {
    API.SendSms(registerForm.getFieldValue('phone'), 'new').then(res => {
      if (res.code === 200) {
        setCountDown(60)
        setDisabled(true)
        setSendingCaptcha(true)
        message.success({
          content: '发送验证码成功，请注意查收',
          duration: 2,
        })
      } else if (res.code === 400) {
        message.error({
          content: '输入手机号不正确，请重新输入',
          duration: 2,
        })
      }
    })
  }

  const handlePhoneChange = (changedValues, allValues) => {
    let pattern = /^1[3|4|5|7|8|9][0-9]\d{8}$/
    if (!sendingCaptcha && pattern.test(allValues.phone)) {
      setDisabled(false)
    } else if (sendingCaptcha || !pattern.test(allValues.phone)) {
      setDisabled(true)
    }
  }

  // 判断用户协议的css状态
  // init 初始   tick 勾选  cancel 取消 
  const [check, setCheck] = useState('init');
  const onChange = (input: CheckboxChangeEvent) => {
    console.log(`checked = ${input.target.checked}`);
    if (input.target.checked) {
      setCheck('tick');
    } else {
      setCheck('cancel');
    }
  };

  //判断多选框的勾选状态
  const checksta = check === 'tick' ? true : false;

  //没勾选用户协议，直接点击下一步，修改check状态
  const nexTest = () => {
    if (check === 'init') {
      setCheck('cancel');
    }
  }

  // 用户协议模块开始
  const [open, setOpen] = useState(false);
  // 打开弹窗
  const showModal = () => {
    setOpen(true);
    setCheck('init');
  };
  // 确认--关闭弹窗
  const hideModalT = () => {
    setOpen(false);
    setCheck('tick');
  };
  // 取消--关闭弹窗
  const hideModalF = () => {
    setOpen(false);
    setCheck('cancel');
  };
  // 用户协议结束

  return (
    <>
      <RegisterSteps current={0} />
      <Form onFinish={register} form={registerForm} onValuesChange={handlePhoneChange}>
        <Form.Item name="phone" rules={phoneRules}>
          <Input
            className="login-input"
            size="large"
            placeholder="手机号"
            prefix={<MobileOutlined style={{ color: '#BFBFBF' }}
              disabled={true}
            />}
            maxLength={11}
            allowClear
          />
        </Form.Item>
        <Form.Item style={{ marginBottom: 0 }}>
          <Row justify="space-between">
            <Col span={16}>
              <Form.Item name="captcha" rules={captchaRules}>
                <Input
                  className="login-input"
                  size="large"
                  placeholder="验证码"
                  maxLength={6}
                  prefix={<SafetyCertificateOutlined style={{ color: '#BFBFBF' }}
                  />}
                />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Button
                size="large"
                className="login-captcha-button"
                onClick={handleClickCaptcha}
                disabled={disabled}
              >
                {sendingCaptcha ? countDown + 's' : '获取验证码'}
              </Button>
            </Col>
          </Row>
        </Form.Item>
        <Form.Item name="remember" valuePropName="checked" noStyle>
          <Checkbox onChange={onChange} checked={checksta}>
          </Checkbox>
          <span className={`checkspan ${check === 'cancel' ? 'agreement-false' : ""}`}>我已阅读并同意</span>
          <span className={"checktip"} onClick={showModal}>《用户协议》</span>
        </Form.Item>
        <Form.Item>
          <Button
            type="primary"
            htmlType="submit"
            size="large"
            className="login-form-button"
            style={{ marginTop: 16 }}
            onClick={nexTest}
          >
            下一步
          </Button>
        </Form.Item>
      </Form>
      {/*用户协议弹窗  */}
      <Modal
        title="用户协议"
        open={open}
        onOk={hideModalT}
        onCancel={hideModalF}
        okText="确认"
        cancelText="取消"
        wrapClassName={classNames(styles['query-modal'])}
      >
        <AgreementCom />
      </Modal>
    </>
  )
}

export default QueryCom
